import React from 'react';
import { EdgeProps, getBezierPath } from '@xyflow/react';

const SimpleEdge: React.FC<EdgeProps> = ({
    id,
    sourceX,
    sourceY,
    targetX,
    targetY,
    sourcePosition,
    targetPosition,
    markerEnd
  }) => {
  const [edgePath] = getBezierPath({ sourceX, sourceY, sourcePosition, targetX, targetY, targetPosition });

  return (
      <path id={id} d={edgePath} stroke="#222" strokeWidth={2} fill="none" markerEnd={markerEnd} />
  );
};

export default SimpleEdge;
